import { StyleSheet } from 'react-native';
import { Colors } from '@shared/styles';

/*
TODO the answer to the iOS chat input misalignment lies in here
*/

export const UnvalidatedStyles = {
  input: {
    height: 40,
    backgroundColor: 'transparent',
    textRendering: 'geometricPrecision',
  },
  // We have slightly different heights on web and native.
  // On web we need to be as tall as the old chat keyboard
  // (which might be next to the new eg in chat/task details)
  inputPaddingNormal: 12,
  inputPaddingLarge: 20,
  border: {
    borderRadius: 6,
    borderColor: Colors.gray.light,
    borderWidth: 1,
  },
};

export const Styles = StyleSheet.create({
  default: {
    alignSelf: 'stretch',
    textRendering: 'geometricPrecision',
  },
  border: {
    borderRadius: 6,
    borderColor: Colors.gray.light,
    borderWidth: 1,
  },
  focusedBorder: {
    borderColor: Colors.v2.green30,
  },
  padding: {
    paddingVertical: 10,
    paddingHorizontal: 10,
  },
  removeAndroidDefaultPadding: {
    padding: 0,
  },
});
